<h2 class="pb-[2.5rem]">{{ 'faq.title' | transloco }}</h2>
@if(loading()){
<div class="my-[6.25rem]"><loader /></div>
} @else {
<div
  class="flex flex-col p-[2.5rem] mb-[2.5rem] gap-[2rem] bg-white rounded-3xl text-2xl"
>
  @if (!loading && (!faqs || faqs.length === 0)) {
  <p class="text-vinciGrey-500">{{ 'faq.noQuestions' | transloco }}</p>
  } @for (faq of faqs; track $index; let last = $last) {
  <details class="w-full">
    <summary class="flex justify-between items-center group cursor-pointer">
      {{faq.question}}
      <span
        class="flex items-center justify-center bg-vinciGrey-100 group-hover:bg-vinciGrey-200 rounded-[62.4375rem] w-[2.625rem] h-[2.625rem] transition-colors duration-300"
      >
        <icon
          [name]="'nav-arrow-down'"
          [size]="'0.875rem'"
          class="icon-closed mb-[1.25rem]"
        ></icon>
        <icon
          [name]="'nav-arrow-up'"
          [size]="'0.875rem'"
          class="icon-open mb-[1.5rem]"
        ></icon>
      </span>
    </summary>
    <div
      class="wysiwyg !text-base text-vinciGrey-600 pt-[2rem]"
      [innerHTML]="faq.answerHtml | safeHtml"
    ></div>
  </details>
  @if (!last) {
  <div class="h-[0.0625rem] rounded-l bg-vinciGrey-400"></div>
  } }
</div>

<div class="flex justify-end w-full mb-[5rem]">
  <app-button
    [text]="'faq.ctaText' | transloco"
    [variant]="'secondary'"
    [icon]="'arrow-left'"
    [iconPosition]="'left'"
    (buttonClick)="redirectToHomepage()"
  ></app-button>
</div>
}
